import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { formGridProps } from "@store/theme/props/form";

export enum GapPreset {
    Form = "Form",
}

export const getGapPresetData = (gapPreset: string): GridContainerProps | null => {
    switch (gapPreset) {
        case GapPreset.Form:
            return formGridProps;
        default:
            return null;
    }
};

export const gridGapPresetFieldOptions = [
    {
        displayName: "Form",
        value: GapPreset.Form,
    },
];

const gridGapPresetField = {
    displayName: "Gap Preset",
    tooltip: "Do not choose a preset if you wish to customize the gap",
    editorTemplate: "DropDownField",
    options: gridGapPresetFieldOptions,
    defaultValue: "",
    fieldType: "General",
} as DropDownFieldDefinition<string>;

export default gridGapPresetField;
